var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 23C3 11.9543 11.9543 3 23 3C34.0457 3 43 11.9543 43 23C43 34.0457 34.0457 43 23 43C11.9543 43 3 34.0457 3 23Z",
    fill: "#D1FADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3332 22.2334V23C31.3321 24.797 30.7503 26.5456 29.6743 27.9849C28.5983 29.4242 27.0859 30.4771 25.3626 30.9866C23.6394 31.4961 21.7976 31.4349 20.1119 30.8122C18.4262 30.1894 16.987 29.0384 16.009 27.5309C15.0309 26.0234 14.5663 24.2401 14.6846 22.447C14.8028 20.6538 15.4975 18.947 16.6651 17.5809C17.8326 16.2149 19.4105 15.2628 21.1633 14.8668C22.9162 14.4708 24.7501 14.652 26.3915 15.3834M31.3332 16.3334L22.9998 24.675L20.4998 22.175",
    stroke: "#039855",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 40C13.6112 40 6 32.3888 6 23H0C0 35.7025 10.2975 46 23 46V40ZM40 23C40 32.3888 32.3888 40 23 40V46C35.7025 46 46 35.7025 46 23H40ZM23 6C32.3888 6 40 13.6112 40 23H46C46 10.2975 35.7025 0 23 0V6ZM23 0C10.2975 0 0 10.2975 0 23H6C6 13.6112 13.6112 6 23 6V0Z",
    fill: "#ECFDF3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMsgIcon);
export default __webpack_public_path__ + "static/media/success-msg-icon.d3fde079139479b94e74ecab4ab56e6d.svg";
export { ForwardRef as ReactComponent };